import React, { useState, useEffect } from "react";
import "./App.css";
import ProfileCard from "./components/ProfileCard.js";

const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleLoad = () => setIsLoaded(true);
    window.addEventListener("load", handleLoad);

    // Set isLoaded to true immediately if the document is already loaded
    if (document.readyState === "complete") {
      setIsLoaded(true);
    }

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  if (!isLoaded) {
    return <div className="loading-spinner">Loading...</div>; // O muestra un spinner de carga si prefieres
  }

  return (
    <div className="app-container">
      <ProfileCard />
    </div>
  );
};

export default App;
